// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreatePrescriberRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentCreatePrescriberRequestModel.attributeTypeMap;
    }
}
EnrollmentCreatePrescriberRequestModel.discriminator = undefined;
EnrollmentCreatePrescriberRequestModel.additionalProperties = false;
EnrollmentCreatePrescriberRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "postalCode",
        "baseName": "postalCode",
        "type": "string"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "TCSSource"
    },
];
//# sourceMappingURL=enrollmentCreatePrescriberRequestModel.js.map